var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit, ElementRef, EventEmitter, } from '@angular/core';
import { config } from '../../../../config/config';
import readXlsxFile from 'read-excel-file';
import { BaseComponent } from '../base.component';
import { SuccessWrapComponent } from '../success.wrap/success.wrap.component';
var FileSelectorComponent = /** @class */ (function (_super) {
    __extends(FileSelectorComponent, _super);
    function FileSelectorComponent() {
        var _this = _super.call(this) || this;
        _this.sizeLimit = config.eventImageSizeLimit;
        _this.multiple = false;
        _this.accept = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel';
        _this.onRead = new EventEmitter();
        _this.isShowUploadingSpinner = false;
        _this.separator = ',';
        _this.records = [];
        return _this;
    }
    FileSelectorComponent.prototype.ngOnInit = function () { };
    FileSelectorComponent.prototype.uploadListener = function ($event) {
        var _this = this;
        var files = $event.srcElement.files;
        console.log('files', files);
        // for uploading csv events
        if (!this.multiple && files[0].type.includes('officedocument.spreadsheet')) {
            readXlsxFile(files[0]).then(function (rows) {
                // `rows` is an array of rows
                // each row being an array of cells.
                _this.onRead.emit(rows);
            });
        }
        else {
            this.onRead.emit(files);
        }
        return;
        // if (this.isValidCSVFile(files[0])) {
        //
        //     let input = $event.target;
        //     let reader = new FileReader();
        //     reader.readAsText(input.files[0]);
        //
        //     reader.onload = () => {
        //         let csvData = reader.result;
        //         let result = this.csvToJSON(csvData);
        //         // let csvRecordsArray = (<string>csvData).split(/\r\n|\n/);
        //         //
        //         //let headersRow = this.getHeaderArray(csvRecordsArray);
        //         //
        //         // this.records = this.getDataRecordsArrayFromCSVFile(csvRecordsArray, headersRow.length);
        //         this.onRead.emit(result);
        //     };
        //
        //     reader.onerror = function () {
        //         console.log('error is occured while reading file!');
        //     };
        //
        // } else {
        //     alert("Please import valid .csv file.");
        //     this.fileReset();
        // }
    };
    FileSelectorComponent.prototype.getDataRecordsArrayFromCSVFile = function (csvRecordsArray, headerLength) {
        var csvArr = [];
        for (var i = 1; i < csvRecordsArray.length; i++) {
            var curruntRecord = csvRecordsArray[i].split(',');
            if (curruntRecord.length == headerLength) {
                var csvRecord = new CSVRecord();
                csvRecord.content1 = curruntRecord[0].trim();
                csvRecord.content2 = curruntRecord[1].trim();
                csvRecord.content3 = curruntRecord[2].trim();
                csvArr.push(csvRecord);
            }
        }
        return csvArr;
    };
    FileSelectorComponent.prototype.isValidCSVFile = function (file) {
        return file.name.endsWith('.csv');
    };
    FileSelectorComponent.prototype.getHeaderArray = function (csvRecordsArr) {
        var headers = csvRecordsArr[0].split(',');
        var headerArray = [];
        for (var j = 0; j < headers.length; j++) {
            headerArray.push(headers[j]);
        }
        return headerArray;
    };
    FileSelectorComponent.prototype.csvToJSON = function (content) {
        var lines = content.split('\n');
        var result = [];
        var start = 0;
        var columnCount = lines[0].split(this.separator).length;
        var headers = [];
        //if (content.header) {
        headers = lines[0].split(this.separator);
        start = 1;
        //}
        for (var i = start; i < lines.length; i++) {
            var obj = {};
            var currentline = lines[i].split(new RegExp(this.separator + '(?![^"]*"(?:(?:[^"]*"){2})*[^"]*$)'));
            if (currentline.length === columnCount) {
                //if (content.header) {
                for (var j = 0; j < headers.length; j++) {
                    obj[headers[j]] = currentline[j];
                }
            }
            else {
                for (var k = 0; k < currentline.length; k++) {
                    obj[k] = currentline[k];
                }
                result.push(obj);
            }
        }
        return result;
    };
    FileSelectorComponent.prototype.fileReset = function () {
        this.csvReader.nativeElement.value = '';
        this.records = [];
    };
    FileSelectorComponent.prototype.showSpinner = function () {
        this.isShowUploadingSpinner = true;
    };
    FileSelectorComponent.prototype.hideSpinner = function () {
        this.isShowUploadingSpinner = false;
    };
    return FileSelectorComponent;
}(BaseComponent));
export { FileSelectorComponent };
var CSVRecord = /** @class */ (function () {
    function CSVRecord() {
    }
    return CSVRecord;
}());
export { CSVRecord };



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/common/components/file.selector/file.selector.component.ts.pre-build-optimizer.js